// Public (anonymous) catalog endpoints — no auth required.
export const PUBLIC_VIDEOS_PATH = 'public/videos';
export const PUBLIC_CATEGORIES_PATH = 'public/categories';
